<template>
<div>
    <!-- OLDER DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
    <!-- OLD VERSION <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid"> -->
    <div>
        <div class="wrapper">
            <div class="container-wrapper">
                <div id="alerts-container">
                </div>
            </div>
        </div>
        <!-- <div class="col-xs-12"> -->
        <div>
            <div class="account-item">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <div class="row">
                            <div class="col-xs-12 col-md-6">
                                <h3 class="panel-title">
                           <span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>
                           Cash Markets
                         </h3>
                            </div>
                            <div class="col-md-6 text-right">
                                <button class="btn btn-default" data-toggle="modal" data-target="#_sQuestionsModal">SOLICITAR OFERTA</button>
                            </div>
                        </div>
                    </div>
                    <div class="panel-body">
                        <div class="table-responsive">
                            <table class="table m-0">
                                <thead>
                                    <tr>
                                        <th>Fecha de Solicitud</th>
                                        <th>Oferta</th>
                                        <th>Monto Solicitado</th>
                                        <th>Monto Pagado</th>
                                        <th>Monto Pendiente</th>
                                        <th>Próximo descuento</th>
                                        <th>Monto para saldar</th>
                                        <th>Saldar Préstamo</th>
                                    </tr>
                                </thead>
                                <tbody v-for="transaction in transactions">
                                    <tr v-if="transaction.pending_amount != 0">
                                        <td>{{transaction.created_at}}</td>
                                        <td>{{transaction.offer.title}}</td>
                                        <td>RD{{transaction.principal_amount | currency}}</td>
                                        <td>
                                            RD{{((transaction.principal_amount * 1 + transaction.interest_amount *1) - transaction.pending_amount) | currency}}
                                        </td>
                                        <td>RD{{transaction.pending_amount | currency}}</td>
                                        <td>RD{{transaction.due_amount | currency}}</td>
                                        <td>RD{{transaction.pending_amount | currency}}</td>
                                        <td>No Disponible</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- modal-content -->
        <div class="modal fade" id="_confirmLogoutModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Logout</h4>
                    </div>
                    <div class="modal-body">
                        ¿Estás seguro que desea salir del sistema?
                    </div>
                    <div class="modal-footer">
                        <div class="row">
                            <div class="col-md-12 pull-right">
                                <a data-dismiss="modal" class="btn btn-default">VOLVER</a>
                                <a class="btn btn-primary" id="_submitLogout">LOGOUT</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->

        <!-- modal-content request offer-->
        <div class="modal fade" id="request-offer">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click=""><span aria-hidden="true">&times;</span></button>
                        <h3 class="text-bold">CashMarket <span class="p-l-5 m-l-5 b-l b-grey">Ofertas</span></h3>
                    </div>
                    <div class="modal-body">
                        <div class="col-xs-12 text-center">
                            <div class="offer-price text-right">
                                <label>Monto Disponible</label>
                                <h3 class="m-0">RD{{ salaryAmount | currency }}</h3>
                            </div>
                        </div>
                        <hr>
                        <form>
                            <div class="col-xs-12  col-lg-6 m-t-20">
                                <div class="form-group col-xs-12">
                                    <label>Proveedor</label>
                                    <select class="form-control" v-model="selectedProvider" @change="getSelectedProviderInfo(selectedProvider)">
                                        <option value="0">Seleccionar</option>
                                        <option v-for="provider in providers" :value="provider.id">{{ provider.name }}</option>
                                    </select>
                                </div>

                                <div class="form-group col-xs-12 m-t-20">
                                    <label>Ofertas</label>
                                    <select class="form-control" v-model="selectedProduct" @change="getSelectedOffer(selectedProduct)">
                                        <option v-for="product in products" :value="product.id">{{product.title}}</option>
                                    </select>
                                </div>

                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <label>Teléfono de proveedor</label>
                                    <input type="phone" class="form-control" name="telephone" v-model="selectedProviderInfo.phone" disabled>
                                </div>

                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <label>Correo Electrónico</label>
                                    <input type="email" class="form-control" name="email" v-model="selectedProviderInfo.email" disabled>
                                </div>
                                <div class="form-group col-xs-12 m-t-20">
                                    <label>Descripción de la Oferta</label>
                                    <textarea type="text" v-model="selectedOffer.description" class="form-control "></textarea>
                                </div>
                            </div>

                            <div class="col-xs-12  col-lg-6 m-t-20">
                                <div class="checkbox check-default col-xs-12">
                                    <input type="checkbox" value="1" id="checkbox1" v-model="itibis">
                                    <label for="checkbox1">ITBIS Incluido</label>
                                </div>
                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <label>Valor de la oferta</label>
                                    <div>
                                        <input
                                            type="number"
                                            
                                            class='form-control'
                                            v-model="amount">
                                    </div>
                                </div>
                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <label>Monto Avance</label>
                                    <input
                                        type="number"
                                        class='form-control'
                                        v-model="initialAmount"
                                        required>
                                </div>
                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <label>Porcentaje de Comisión</label>
                                    <div>
                                        <input
                                            type="number"
                                            class='form-control'
                                            min="0"
                                            max="30"
                                            v-model="comission_percent"
                                            required>
                                    </div>
                                </div>
                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <label>Monto Total</label>
                                    <input
                                        disabled
                                        type="number"
                                        class='form-control'
                                        min="0"
                                        max="30"
                                        v-model="totalAmount"
                                        required>
                                </div>
                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <label>Monto Factura</label>
                                    <input
                                        disabled
                                        type="number"
                                        class='form-control'
                                        min="0"
                                        max="30"
                                        v-model="billAmount"
                                        required>
                                </div>
                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <label>Cuotas de Pago</label>
                                    <input type="number" class="form-control" name="cuotas" v-model="fee">
                                </div>
                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <label>Cargar Comprobante</label>
                                    <input class="form-control" name="cuotas">
                                </div>
                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <a class="btn btn-default m-t-25" data-dismiss="modal">Cargar</a>
                                </div>
                                <div class="clearfix"></div>
                                <div class="form-group col-xs-12 col-lg-6 m-t-20">
                                    <label>Fecha de Inicio</label>
                                    <div id="first-date" class="input-group date">
                                        <input type="text" class="form-control" placeholder="00/00/00" v-model="selectedOffer.start_date" id="startDate">
                                        <span class="input-group-addon bg-white"><i class="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                </div>
                                <!-- <div class="form-group col-xs-12 col-lg-6 m-t-20" v-if="selectedOffer.service_type_id == 2">
                                    <label>Fecha de Vencimiento</label>
                                    <div id="due-date" class="input-group date">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="00/00/00"
                                            v-model="selectedOffer.due_date"
                                            id="dueDate">
                                        <span class="input-group-addon bg-white"><i class="fa fa-calendar"></i>
                                        </span>
                                    </div>
                                </div> -->
                                <div class="checkbox check-default m-t-30 col-xs-12">
                                    <input name="invalidarSalario" v-model="invalidarSalario" type="checkbox" checked="checked" value="1" id="invalidarSalario">
                                    <label for="invalidarSalario">Saltarse Monto Disponible</label>
                                </div>
                                <div class="checkbox check-default m-t-30 col-xs-12">
                                    <input type="checkbox" checked="checked" value="1" id="checkbox2">
                                    <label for="checkbox2">Indefinido</label>
                                </div>
                                <div class="clearfix"></div>
                                <div class="col-md-6">
                                    <p>
                                        Usted está solicitando la oferta {{selectedOffer.title}} de un valor RD$ {{amount}} está dispuesto a pagar RD$ {{paymentAmount.toFixed(2)}} en su próximo pago quincenal en {{selectedOffer.start_date}}.
                                    </p>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </form>
                        <div class="clearfix"></div>
                    </div>
                    <div class="modal-footer text-center">
                        <div class="row">
                            <div class="col-md-12">
                                <a class="btn btn-default" data-dismiss="modal">CANCELAR</a>
                                <a class="btn btn-default" @click="applyOffer()">APLICAR</a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->

        <div class="modal fade" id="_sQuestionsModal" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Acceder a usuario</h4>
                    </div>
                    <div class="container-fluid" id="QuickCash">
                        <div class="modal-body">
                            <div class="alert alert-danger" style="display:none;">
                            </div>
                            <div class="questions-container">
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>1. ¿Con qué frecuencia recibe su salario?</strong></p>
                                        <div class="form-group input-group">
                                            <label for="radio_1_4">
                                                    <input type="radio" id="radio_1_4" data-question-type="4" name="question_type_4" value="1" v-model="salaryRate"> Mensual</label>
                                            <br>
                                            <label for="radio_2_4"><input type="radio" id="radio_2_4" data-question-type="4" name="question_type_4" value="2" v-model="salaryRate"> Quincenal</label><br>
                                            <label for="radio_3_4">
                                                    <input type="radio" id="radio_3_4" data-question-type="4" name="question_type_4" value="3" v-model="salaryRate"> Semanal</label><br>
                                            <label for="radio_4_4"><input type="radio" id="radio_4_4" data-question-type="4" name="question_type_4" value="4" v-model="salaryRate"> Bi Semanal</label>
                                            <br>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>2. ¿Ha solicitado Cash Market anteriormente?</strong></p>
                                        <div class="form-group input-group">
                                            <label for="radio_true_1">
                                                    <input
                                                        type="radio"
                                                        id="radio_true_1"
                                                        data-question-type="1"
                                                        name="question_type_1"
                                                        value="1"
                                                        v-model="cashmarket">
                                                        Si
                                            </label>
                                            <br>
                                                <label for="radio_false_1">
                                                    <input
                                                        type="radio"
                                                        id="radio_false_1"
                                                        data-question-type="1"
                                                        name="question_type_1"
                                                        value="0"
                                                        v-model="cashmarket"> No
                                                </label>
                                            <br></div>
                                    </div>
                                </div>
                                 <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>3. ¿Por cuánto tiempo ha estado trabajando en esa empresa?</strong></p>
                                        <div class="form-group input-group">
                                            <label for="radio_0_6"><input type="radio" id="radio_0_6" data-question-type="6" name="question_type_6" value="0"> 0 años</label><br>
                                            <label for="radio_1_6"><input type="radio" id="radio_1_6" data-question-type="6" name="question_type_6" value="1"> 1 años</label><br>
                                            <label for="radio_3_6"><input type="radio" id="radio_3_6" data-question-type="6" name="question_type_6" value="3"> 3 años</label><br>
                                            <label for="radio_5_6"><input type="radio" id="radio_5_6" data-question-type="6" name="question_type_6" value="5"> 5 años</label><br>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <p><strong>2. ¿Ha solicitado Quick Cash anteriormente?</strong></p>
                                    <div class="form-group input-group">
                                        <label for="radio_true_1">
                                            <input type="radio" id="radio_true_1" data-question-type="1" name="question_type_1" value="true"> Si</label><br>
                                            <label for="radio_false_1"><input type="radio" id="radio_false_1" data-question-type="1" name="question_type_1" value="false"> No</label><br>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="row">
                                <div class="col-md-12 pull-right">
                                    <a href="#" data-dismiss="modal" class="btn btn-default">CANCELAR</a>
                                    <button type="submit" class="btn btn-default" @click="confirmUser()">ACCEDER</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            billAmount: 0,
            salaryAmount: 0,
            invalidarSalario: false,
            comission_percent: 0,
            initialAmount: 0,
            totalAmount: 0,
            providers: [],
            selectedProvider: '',
            providerPhone: '',
            providerEmail: '',
            itibis: '',
            amount: 0,
            maxAmount: 0,
            fee: 2,
            startDate: '',
            interest: '',
            products: [],
            selectedProduct: '',
            salaryFrequency: '',
            companyId: '',
            profileId: '',
            selectedProviderInfo: [],
            selectedOffer: {},
            transactions: {},
            salaryRate: 0,
            cashmarket: 0,
            user: {},
        }
    },
    ready() {
        this.getEmployee();
        this.getProvider();
        this.getProducts();
        this.cleanMyModal();
    },
    watch: {
        'initialAmount'() {
            this.updateTotalAmount();
            if (this.initialAmount > this.totalAmount) {
                swal("Advertencia", "El monto factura no puede acceder el monto total de la oferta", "warning");
                this.initialAmount = this.totalAmount;
            } else {
                this.billAmount = this.totalAmount - this.initialAmount;
            }
        },
        'itibis'() {
            if(this.itibis) {
                this.totalAmount = Number(this.itibisAmount).toFixed(2);
            } else {
                this.updateTotalAmount();
            }
        },
        'amount'(){
            this.updateTotalAmount();
        },
        'comission_percent'(){
            this.updateTotalAmount();
        },
        'fee'(){
            this.updateTotalAmount();
        }
    },
    methods: {
        updateTotalAmount(){
            this.totalAmount = Number(this.amount) + (Number(this.amount * this.comission_percent/100) *this.fee);
        },
        clearFields() {
            this.amount = 0;
            this.initialAmount = 0;
            this.comission_percent = 0;
            this.totalAmount = 0;
            this.itibis = false;
        },
        getEmployee: function() {
            this.$http.get(apiUrl + '/employees/' + this.$route.params.id + '?relationships=transactions').then(response => {
                console.log(response);
                this.salaryAmount = response.data.available_amount;
                this.salaryFrequency = response.data.salary_frequency_id;
                this.companyId = response.data.company_id;
                this.profileId = response.data.profile_id;
                this.transactions = response.data.transaction;
                this.user = response.data;
                $('#startDate').datepicker();
            });
        },
        confirmUser: function() {
            let hasUserMarket = 0;
            if (this.user.transactions) {
                hasUserMarket = this.user.transactions.length > 0 ? 1 : 0;
            }

            if (this.salaryRate == this.user.salary_frequency_id && hasUserMarket == this.cashmarket) {
                this.salaryRate = '';
                this.cashmarket = '';
                $('#_sQuestionsModal').modal('toggle');
                $('#request-offer').modal('show');
            } else {
                $('#_sQuestionsModal').modal('toggle');
                this.cashmarket = '';
                this.salaryRate = '';
                sweetAlert("Oops...", "No has dado respuesta a toda las preguntas de manera correcta", "error");
            }
        },
        getSelectedProviderInfo: function(id) {
            this.clearFields();
            let fillInfo = this.providers.find((provider) => {
                return provider.id == id;
            });

            this.products = [];
            this.selectedProviderInfo = fillInfo;
            //update dropdown
            this.$http.get(apiUrl + '/offers?q=(is_deleted:0,provider_id:' + this.selectedProviderInfo.id + ')&limit=1000').then(response => {
                this.products = response.data;
            });
        },
        getSelectedOffer: function(id) {
            this.clearFields();
            let fillInfo = this.products.find((products) => {
                return products.id == id;
            });

            this.selectedOffer = fillInfo;
            this.maxAmount = this.selectedOffer.amount;
            this.amount = this.selectedOffer.amount;
            this.comission_percent = this.selectedOffer.comission_percent;
            this.totalAmount = Number(this.amount) + Number(this.amount * this.comission_percent/100);
            if (Number(this.selectedOffer.fee)) {
                this.fee = this.selectedOffer.fee;
            }
        },
        getProvider: function() {
            this.$http.get(apiUrl + '/providers').then(response => {
                this.providers = response.data;
            });
        },
        getProducts: function() {
            this.$http.get(apiUrl + '/offers?q=(is_deleted:0)').then(response => {

                this.products = response.data.data;
            });
        },
        cleanMyModal: function() {
            $('#request-offer').on('hidden.bs.modal', (e) => {
                this.selectedProvider = '';
                this.selectedProviderInfo = '';
            });
        },
        applyOffer: function() {
            let self = this;
            if (this.invalidarSalario || parseInt(this.salaryAmount) >= parseInt(this.itibisAmount)) {
               
                var data = {}
                data["employee_id"] = this.$route.params.id;
                data["user_id"] = this.$route.params.id;
                data["product_id"] = this.selectedProduct;
                data["offer_id"] = this.selectedProduct;
                data["provider_id"] = this.selectedProvider;
                data["amount"] = this.amount;
                data["fee_amount"] = this.feeInterest;
                data["payment_amount"] = this.paymentWithoutInterest;
                data['start_date'] = this.selectedOffer.start_date;
                data['due_date'] = '2019-01-01';
                data["total_amount"] = this.totalAmountToPay;
                data["current_debt_amount"] = this.totalAmountToPay;
                data["principal_amount"] = this.amount;
                data["fee"] = this.fee;
                data["salaryFrequency"] = this.salaryFrequency;
                data["company_id"] = this.companyId;
                data["profile_id"] = this.profileId;
                data["comission_percent"] = this.comission_percent;
                data["due_amount"] = this.initialAmount;


                this.$http({
                    emulateJSON: true,
                    emulateHTTP: true,
                    url: apiUrl + '/loan-requests',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: data,
                }).then(function(response) {
                    //swal("Felicidades !", "Solicitud por la Oferta " + self.selectedOffer.title + ' Enviada', "success");
                    swal({
                            title: "Felicidades !",
                            text: "Solicitud por la Oferta " + self.selectedOffer.title + ' Enviada',
                            type: "success"
                        },
                        function() {
                            ///sleep(2000);
                            location.reload();
                        }
                    );
                    $('#request-offer').modal('toggle');
                    //sleep(1000);
                    //window.location.reload();
                }, response => {
                    sweetAlert("Oops...", "Ha ocurrido un error !", "error");
                });
            } else {
                sweetAlert("Oops...", "Empleado no provee suficiente monto para esta oferta", "error");
                //alert('Empleado no provee suficiente monto para esta oferta');
            }
        },
    },
    computed: {
        itibisAmount: function() {
            return Number(this.totalAmount) + Number(this.totalAmount * 0.18);
        },
        paymentAmount: function() {
            return parseInt(this.totalAmount) / parseInt(this.fee) + parseInt(this.feeInterest);
        },
        paymentWithoutInterest: function() {
            return parseInt(this.amount) / parseInt(this.fee);
        },
        feeInterest: function() {
            return (this.amount * this.interest);
        },
        interestToEarn: function() {
            return ((this.amount * (this.comission_percent/100)) * this.fee);
        },
        totalAmountToPay: function() {
            return parseInt(this.amount) + parseInt(this.interestToEarn);
        },
    }
}
</script>



// WEBPACK FOOTER //
// apply-offer.vue?647d4858